import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { AppinfoService } from './appinfo.service';
import { AppSettings } from '../app.settings';
import { SettingsNinjaService } from './settings-ninja.service';

@Injectable()
export class ResolverCustomerAppInfoService implements Resolve<any> {

	constructor(
		private appinfoService: AppinfoService,
		private ninjaService: SettingsNinjaService
	) { }
	async resolve(route: ActivatedRouteSnapshot) {
		const appName = route.data.appName;
		let info;
		if (appName === AppSettings.lbeAppName) {
			info = await this.appinfoService.getCustomerAppInfoLBE();
		} else if (appName === AppSettings.ninjaAppName) {
			info = await this.appinfoService.getCustomerAppInfoNinja();
			this.ninjaService.ninjaDefaults = info.defaults;
		} else {
			info = await this.appinfoService.getCustomerAppInfo(appName);
		}
		return info;
	}
}



// WEBPACK FOOTER //
// ./src/app/common-services/resolver-customer-app-info.service.ts